import React, { FC } from 'react'
import { Grid, GridProps } from '@mui/material'

const EvtGrid: FC<GridProps> = ({ children, ...props }) => {
    return <Grid {...props}>{children}</Grid>
}

export default EvtGrid
